// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"5a611171","147":"894fe0ff","564":"ac0ae02d","574":"7a33d087","754":"2f104dae","842":"30e03327","900":"fe42f209","926":"a87cdd98"}[chunkId] + ".chunk.js";
};